import Swiper from "swiper";

class CarouselContainerElement extends HTMLElement {
  declare swiper: Swiper;

  connectedCallback() {
    let that = this;
    let [offsetBefore, offsetAfter] = offsets(this.getAttribute("size"));
    this.swiper = new Swiper(this.querySelector<HTMLElement>(".swiper")!, {
      grabCursor: true,
      centeredSlides: true,
      spaceBetween: 8,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: offsetAfter,
      on: {
        resize(swiper) {
          let [offsetBefore, offsetAfter] = offsets(that.getAttribute("size"));
          swiper.params.slidesOffsetBefore = offsetBefore;
          swiper.params.slidesOffsetAfter = offsetAfter;
          swiper.update();
        },
      },
    });
  }
}

customElements.define("carousel-container", CarouselContainerElement);

function offsets(size: string | null): [number, number] {
  let gap = 8;
  let columns = innerWidth < 960 ? 6 : 12;
  let columnsLeft, columnsRight;
  if (size == "sm") {
    if (innerWidth >= 2560) {
      columnsLeft = 2;
      columnsRight = 8;
    } else if (innerWidth >= 1920) {
      columnsLeft = 2;
      columnsRight = 8;
    } else if (innerWidth >= 1280) {
      columnsLeft = 1;
      columnsRight = 8;
    } else if (innerWidth >= 960) {
      columnsLeft = 0;
      columnsRight = 7;
    } else if (innerWidth >= 640) {
      columnsLeft = 0;
      columnsRight = 2;
    } else {
      columnsLeft = 0;
      columnsRight = 1;
    }
  } else if (size == "lg") {
    if (innerWidth >= 2560) {
      columnsLeft = 2;
      columnsRight = 2;
    } else if (innerWidth >= 1920) {
      columnsLeft = 2;
      columnsRight = 2;
    } else if (innerWidth >= 1280) {
      columnsLeft = 1;
      columnsRight = 1;
    } else if (innerWidth >= 960) {
      columnsLeft = 0;
      columnsRight = 1;
    } else if (innerWidth >= 640) {
      columnsLeft = 0;
      columnsRight = 1;
    } else {
      columnsLeft = 0;
      columnsRight = 1;
    }
  } else {
    if (innerWidth >= 2560) {
      columnsLeft = 2;
      columnsRight = 5;
    } else if (innerWidth >= 1920) {
      columnsLeft = 2;
      columnsRight = 5;
    } else if (innerWidth >= 1280) {
      columnsLeft = 1;
      columnsRight = 5;
    } else if (innerWidth >= 960) {
      columnsLeft = 0;
      columnsRight = 4;
    } else if (innerWidth >= 640) {
      columnsLeft = 0;
      columnsRight = 1;
    } else {
      columnsLeft = 0;
      columnsRight = 1;
    }
  }
  let columnWidth = (innerWidth - (columns + 1) * gap) / columns;
  let offsetLeft = columnsLeft * columnWidth + (columnsLeft + 1) * gap;
  let offsetRight = columnsRight * columnWidth + (columnsRight + 1) * gap;
  return [offsetLeft, offsetRight];
}
